import { FileInfo } from "../file-info";
import { DeviceMake, DeviceModel } from "./device-model";

export class DeviceInfo {
    DeviceMake: DeviceMake;
    DeviceModel: DeviceModel;
    PurchaseDate: string;
    PurchasePrice: number; 
    InvoiceNumber: string;
    InvoiceDocuments: FileInfo [];
    IsIMEI: string;
    IsUpload: string;
    IsSerialNumber: string;
    serialNumber: string;
    DealerShipProgramType :string;
    SkuNumber: string;
    IsRefurbished: string;
    EquipmentRiskType:string;
    Equipment:string;
    BarCode:string
    constructor(deviceMake: DeviceMake, deviceModel: DeviceModel, devicePurchasePrice: number, devicePurchaseDate: string, invoiceNumber: string, invoiceDocuments: FileInfo[], isImei: string, isUpload: string, isSerialNumber, skuNumber: string,IsFurbished:string,equipmentRiskType:string,equipment:string, barCode:string) {
        this.DeviceMake = deviceMake
        this.DeviceModel = deviceModel;
        this.PurchaseDate = devicePurchaseDate;
        this.PurchasePrice = devicePurchasePrice;
        this.InvoiceNumber = invoiceNumber;
        this.InvoiceDocuments = invoiceDocuments;
        this.IsIMEI = isImei;
        this.IsUpload = isUpload;
        this.IsSerialNumber = isSerialNumber;
        this.SkuNumber = skuNumber;
        this.IsRefurbished = IsFurbished;
        this.EquipmentRiskType=equipmentRiskType;
        this.Equipment=equipment,
        this.BarCode=barCode
    }
  }
